(() => {
  const IS_SESSION_STORAGE_ENABLED = false;

  // QA MGZ-02: Mağazalar sayfası bu ülke seçili açılır (listede varsa).
  const HP_STORE_DEFAULT_COUNTRY = 'Türkiye';

  // Marka isteği 16: `?grup=konsept` ile açılan sayfa yalnızca `group` meta değeri eşleşen mağazaları
  // listeler (iade sayfasındaki link). Parametre yoksa tüm mağazalar gösterilir.
  const HP_STORE_GROUP_PARAM = 'grup';

  // QA MGZ-03: API'nin `country` etiketleri → filtrede gösterilen etiket (mevcut arayüz etiketleri korunur).
  const HP_STORE_COUNTRY_ALIASES = {
    'KUZEY-KIBRIS': 'KKTC',
    TURKIYE: 'Türkiye',
    TURKEY: 'Türkiye',
  };

  const HP_STORE_COUNTRY_BY_CITY = {
    AMMAN: 'Ürdün',
    TIFLIS: 'Gürcistan',
    DUSANBE: 'Tacikistan',
    ERBIL: 'Irak',
    TASKENT: 'Özbekistan',
    LVIV: 'Ukrayna',
    LEFKOSA: 'KKTC',
    FERGANA: 'Özbekistan',
    BAKU: 'Azerbaycan',
    NAMANGAN: 'Özbekistan',
    LUZERN: 'İsviçre',
    BISKEK: 'Kırgızistan',
    ASKABAT: 'Türkmenistan',
    USKUP: 'Kuzey Makedonya',
    ATYRAU: 'Kazakistan',
    ALMATY: 'Kazakistan',
    YEREVAN: 'Ermenistan',
    ASHGABAT: 'Türkmenistan',
    KHUJAND: 'Tacikistan',
    SHYMKENT: 'Kazakistan',
  };

  const HP_STORE_TURKISH_CITIES = new Set([
    'ADANA', 'ADIYAMAN', 'AFYONKARAHISAR', 'ANKARA', 'ANTALYA', 'AYDIN', 'BALIKESIR', 'BATMAN', 'BURSA', 'CORUM',
    'DENIZLI', 'DIYARBAKIR', 'DUZCE', 'ELAZIG', 'ERZURUM', 'GAZIANTEP', 'HATAY', 'ISPARTA', 'ISTANBUL', 'IZMIR',
    'KAHRAMANMARAS', 'KARAMAN', 'KARABUK', 'KARS', 'KASTAMONU', 'KAYSERI', 'KOCAELI', 'KONYA', 'MARDIN', 'MERSIN',
    'MUGLA', 'MUS', 'ORDU', 'SAKARYA', 'SAMSUN', 'SANLIURFA', 'SIRNAK', 'SIIRT', 'SIVAS', 'TRABZON', 'VAN', 'ZONGULDAK',
  ]);

  const HP_STORE_ADDRESS_COUNTRY_RULES = [
    { pattern: /atyrau|almaty|shymkent|nursultan|astana|kokshetau|kokchetau|kazakhstan|kazakistan/i, country: 'Kazakistan' },
    { pattern: /yerevan|erivan|armenia|ermenistan/i, country: 'Ermenistan' },
    { pattern: /tbilisi|tiflis|georgia|gürcistan|gurcistan/i, country: 'Gürcistan' },
    { pattern: /dushanbe|duşanbe|khujand|tajikistan|tacikistan/i, country: 'Tacikistan' },
    { pattern: /erbil|ankawa|iraq|irak/i, country: 'Irak' },
    { pattern: /tashkent|taşkent|samarqand|samarkand|fergana|namangan|uzbekistan|özbekistan|ozbekistan/i, country: 'Özbekistan' },
    { pattern: /lviv|ukraine|ukrayna/i, country: 'Ukrayna' },
    { pattern: /ashgabat|aşkabat|turkmenistan|türkmenistan|turkmenistan/i, country: 'Türkmenistan' },
    { pattern: /baku|bakü|azerbaijan|azerbaycan/i, country: 'Azerbaycan' },
    { pattern: /luzern|switzerland|isviçre|isvicre/i, country: 'İsviçre' },
    { pattern: /bishkek|bişkek|kyrgyz|kırgızistan|kirgizistan/i, country: 'Kırgızistan' },
    { pattern: /skopje|üsküp|uskup|macedonia|makedonya/i, country: 'Kuzey Makedonya' },
    { pattern: /nicosa|lefkoşa|lefkosa|kktc|cyprus|kibris|kıbrıs/i, country: 'KKTC' },
    { pattern: /ramallah|filistin|palestine/i, country: 'Filistin' },
    { pattern: /amman|jordan|ürdün|urdun/i, country: 'Ürdün' },
  ];

  const HP_STORE_ADDRESS_CITY_RULES = [
    { pattern: /atyrau/i, city: 'Atyrau' },
    { pattern: /yerevan|erivan/i, city: 'Yerevan' },
    { pattern: /almaty/i, city: 'Almaty' },
    { pattern: /ashgabat|aşkabat/i, city: 'Aşkabat' },
    { pattern: /khujand/i, city: 'Khujand' },
    { pattern: /shymkent/i, city: 'Shymkent' },
  ];

  const HP_STORE_CITY_COORDINATES = {
    ADANA: { lat: 37.0, lng: 35.3213 },
    ADIYAMAN: { lat: 37.7648, lng: 38.2786 },
    AFYONKARAHISAR: { lat: 38.7507, lng: 30.5567 },
    ANKARA: { lat: 39.9334, lng: 32.8597 },
    ANTALYA: { lat: 36.8969, lng: 30.7133 },
    AYDIN: { lat: 37.856, lng: 27.8416 },
    BATMAN: { lat: 37.8812, lng: 41.1351 },
    BURSA: { lat: 40.1885, lng: 29.061 },
    CORUM: { lat: 40.5506, lng: 34.9556 },
    DENIZLI: { lat: 37.7765, lng: 29.0864 },
    DUZCE: { lat: 40.8438, lng: 31.1565 },
    HATAY: { lat: 36.4018, lng: 36.3498 },
    ISPARTA: { lat: 37.7648, lng: 30.5566 },
    ISTANBUL: { lat: 41.0082, lng: 28.9784 },
    IZMIR: { lat: 38.4192, lng: 27.1287 },
    KAHRAMANMARAS: { lat: 37.5753, lng: 36.9228 },
    KARABUK: { lat: 41.2061, lng: 32.6204 },
    KARS: { lat: 40.6013, lng: 43.0975 },
    KASTAMONU: { lat: 41.3887, lng: 33.7827 },
    KAYSERI: { lat: 38.7312, lng: 35.4787 },
    KONYA: { lat: 37.8746, lng: 32.4932 },
    MERSIN: { lat: 36.8121, lng: 34.6415 },
    MUGLA: { lat: 37.2153, lng: 28.3636 },
    MUS: { lat: 38.9462, lng: 41.7539 },
    ORDU: { lat: 40.9862, lng: 37.8797 },
    SAKARYA: { lat: 40.7569, lng: 30.3783 },
    SAMSUN: { lat: 41.2867, lng: 36.33 },
    SANLIURFA: { lat: 37.1591, lng: 38.7969 },
    SIRNAK: { lat: 37.5164, lng: 42.4611 },
    SIIRT: { lat: 37.9333, lng: 41.9469 },
    SIVAS: { lat: 39.7477, lng: 37.0179 },
    TRABZON: { lat: 41.0027, lng: 39.7168 },
    BALIKESIR: { lat: 39.6484, lng: 27.8826 },
    VAN: { lat: 38.5012, lng: 43.3729 },
    ALMATY: { lat: 43.222, lng: 76.8512 },
    AMMAN: { lat: 31.9539, lng: 35.9106 },
    ASHGABAT: { lat: 37.9601, lng: 58.3261 },
    ASKABAT: { lat: 37.9601, lng: 58.3261 },
    ATYRAU: { lat: 47.0971, lng: 51.9236 },
    BAKU: { lat: 40.4093, lng: 49.8671 },
    BISKEK: { lat: 42.8746, lng: 74.5698 },
    DUSANBE: { lat: 38.5598, lng: 68.787 },
    ERBIL: { lat: 36.1911, lng: 44.0094 },
    FERGANA: { lat: 40.3864, lng: 71.7864 },
    KHUJAND: { lat: 40.2826, lng: 69.6222 },
    LEFKOSA: { lat: 35.1856, lng: 33.3823 },
    LVIV: { lat: 49.8397, lng: 24.0297 },
    LUZERN: { lat: 47.0502, lng: 8.3093 },
    NAMANGAN: { lat: 40.9983, lng: 71.6726 },
    SHYMKENT: { lat: 42.3417, lng: 69.5901 },
    TASKENT: { lat: 41.2995, lng: 69.2401 },
    TIFLIS: { lat: 41.7151, lng: 44.8271 },
    USKUP: { lat: 41.9973, lng: 21.428 },
    YEREVAN: { lat: 40.1792, lng: 44.4991 },
    ERIVAN: { lat: 40.1792, lng: 44.4991 },
    BAGHDAD: { lat: 33.3152, lng: 44.3661 },
    BAGDAT: { lat: 33.3152, lng: 44.3661 },
  };

  function parseStoreMapUrlCoordinates(mapUrl) {
    if (!mapUrl) return null;

    const patterns = [
      /@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/,
      /[?&]q=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/,
      /[?&]ll=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/,
      /!3d(-?\d+(?:\.\d+)?)!4d(-?\d+(?:\.\d+)?)/,
      /[?&]query=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/,
    ];

    for (const pattern of patterns) {
      const match = mapUrl.match(pattern);
      if (!match) continue;

      const latitude = Number.parseFloat(match[1]);
      const longitude = Number.parseFloat(match[2]);

      if (!Number.isNaN(latitude) && !Number.isNaN(longitude)) {
        return { latitude, longitude };
      }
    }

    return null;
  }

  function getStoreCityCoordinates(normalizedCity) {
    if (!normalizedCity) return null;

    if (HP_STORE_CITY_COORDINATES[normalizedCity]) {
      return HP_STORE_CITY_COORDINATES[normalizedCity];
    }

    const cityPrefixes = [
      'ISTANBUL', 'IZMIR', 'ANKARA', 'ANTALYA', 'BURSA', 'ADANA', 'KONYA', 'MERSIN', 'TRABZON', 'SAMSUN', 'KAYSERI',
    ];

    for (const prefix of cityPrefixes) {
      if (normalizedCity.startsWith(prefix)) {
        return HP_STORE_CITY_COORDINATES[prefix] || null;
      }
    }

    return null;
  }

  function normalizeSearchText(value) {
    if (!value) return '';

    return String(value)
      .toLocaleLowerCase('tr-TR')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c');
  }

  function getSearchablePhoneDigits(phone) {
    if (!phone) return '';
    return String(phone).replace(/\D/g, '');
  }

  // ---------------------------------------------------------------------------------------------
  // QA MGZ-04 / MGZ-05 / MGZ-07: mağazalar haritası.
  // Checklist: şehir seçilince harita o şehri göstermeli, "Haritada göster" mağazaya gitmeli, "konumumu
  // kullan" mağazaları harita üzerinde göstermeli. Leaflet + OpenStreetMap kullanılır (API anahtarı
  // gerektirmez). Kütüphane yüklenemezse harita hiç görünmez, sayfa eskisi gibi çalışır.
  // Leaflet nesneleri Alpine'ın reaktif verisine konmaz (proxy / performans sorunu) → WeakMap.
  // ---------------------------------------------------------------------------------------------
  const HP_STORES_LEAFLET = {
    css: 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css',
    cssIntegrity: 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=',
    js: 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js',
    jsIntegrity: 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=',
  };
  const HP_STORES_MAPS = new WeakMap();
  let hpStoresLeafletPromise = null;

  function loadLeaflet() {
    if (window.L?.map) return Promise.resolve(window.L);
    if (hpStoresLeafletPromise) return hpStoresLeafletPromise;

    hpStoresLeafletPromise = new Promise((resolve, reject) => {
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = HP_STORES_LEAFLET.css;
      stylesheet.integrity = HP_STORES_LEAFLET.cssIntegrity;
      stylesheet.crossOrigin = '';
      document.head.appendChild(stylesheet);

      const script = document.createElement('script');
      script.src = HP_STORES_LEAFLET.js;
      script.integrity = HP_STORES_LEAFLET.jsIntegrity;
      script.crossOrigin = '';
      script.onload = () => (window.L?.map ? resolve(window.L) : reject(new Error('Leaflet not available')));
      script.onerror = () => reject(new Error('Leaflet failed to load'));
      document.head.appendChild(script);
    });

    hpStoresLeafletPromise.catch(() => {
      hpStoresLeafletPromise = null;
    });

    return hpStoresLeafletPromise;
  }

  // QA R141: çalışma saatleri gün gün listelenir (API alanları mondayStart … sundayEnd).
  const HP_STORE_WEEK_DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  // Date#getDay() sırası (0 = Pazar).
  const HP_STORE_DAY_BY_INDEX = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  // Section markup'ındaki [data-hp-stores-i18n] JSON'u aktif dildeki metinleri verir; okunamazsa bu
  // Türkçe varsayılanlar kullanılır.
  const HP_STORES_I18N_DEFAULTS = {
    all_countries: 'Tüm ülkeler',
    all_cities: 'Tüm şehirler',
    directions: 'Yol Tarifi',
    hours: {
      today: 'Bugün',
      call: 'Çalışma saatleri için arayınız',
      days: {
        monday: 'Pazartesi',
        tuesday: 'Salı',
        wednesday: 'Çarşamba',
        thursday: 'Perşembe',
        friday: 'Cuma',
        saturday: 'Cumartesi',
        sunday: 'Pazar',
      },
    },
    errors: {
      stores_unavailable: 'Mağaza listesi yüklenemedi. Lütfen sayfayı yenileyip tekrar deneyin.',
      geolocation_unsupported:
        'Tarayıcınız konum paylaşımını desteklemiyor. Ülke ve şehir seçerek mağazaları listeleyebilirsiniz.',
      location_invalid: 'Konumunuz alınamadı. Lütfen tekrar deneyin veya şehir seçin.',
      permission_denied:
        'Konum izni verilmedi. Tarayıcı ayarlarından bu site için konuma izin verin veya şehir seçin. Tema editöründeyseniz önizlemeyi ayrı sekmede açın.',
      position_unavailable: 'Konumunuz belirlenemedi. Cihazınızın konum servisini kontrol edin veya şehir seçin.',
      timeout: 'Konum isteği zaman aşımına uğradı. Tekrar deneyin veya şehir seçin.',
      location_failed: 'Konum alınamadı. Tekrar deneyin veya şehir seçin.',
      location_service_unreachable: 'Konum servisine erişilemiyor. Önizlemeyi ayrı sekmede açın veya şehir seçin.',
      no_store_coordinates: 'Mağazaların konum bilgisi bulunamadı. Şehir seçerek listeleyebilirsiniz.',
    },
  };

  function readHpStoresI18n(root) {
    try {
      const source = root?.querySelector('[data-hp-stores-i18n]')?.textContent;
      const parsed = source ? JSON.parse(source) : null;
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      console.warn('hp-stores: i18n JSON okunamadı', error);
      return {};
    }
  }

  // "errors.timeout" gibi noktalı yolu çözer; yalnızca boş olmayan string döndürür.
  function lookupHpStoresText(source, path) {
    const value = path.split('.').reduce((node, part) => {
      if (!node || typeof node !== 'object' || !Object.prototype.hasOwnProperty.call(node, part)) return undefined;
      return node[part];
    }, source);
    return typeof value === 'string' && value !== '' ? value : '';
  }

  function registerHpStoresPage() {
    window.Alpine.data('hpStoresPage', () => ({
      stores: [],
      filteredStores: [],
      countries: [],
      cities: [],
      loading: true,
      searchQuery: '',
      selectedCountry: 'all',
      selectedCity: 'all',
      userLocation: null,
      nearestStoresRequested: false,
      nearestStoresLoading: false,
      nearestStoresActive: false,
      // Konum hatası mesajı — markup'taki `.hp-stores__location-error` bunu gösterir.
      locationError: '',
      // Eski/iptal edilmiş konum isteklerinin sonucunu yok saymak için artan sayaç.
      locationRequestId: 0,
      countryDropdownOpen: false,
      cityDropdownOpen: false,
      defaultCountryApplied: false,
      mapReady: false,
      i18n: {},
      // URL'deki `grup` parametresinin normalize hâli; boşsa grup filtresi yok.
      groupFilter: '',

      init() {
        this.i18n = readHpStoresI18n(this.$root);
        this.groupFilter = this.normalizeLocation(
          new URLSearchParams(window.location.search).get(HP_STORE_GROUP_PARAM) || ''
        );
        this.getStores();

        this.outsideClickHandler = (event) => {
          if (this.$refs.countrySelect?.contains(event.target) || this.$refs.citySelect?.contains(event.target)) {
            return;
          }
          this.closeAllDropdowns();
        };

        document.addEventListener('click', this.outsideClickHandler);
      },

      destroy() {
        if (this.outsideClickHandler) {
          document.removeEventListener('click', this.outsideClickHandler);
        }

        const mapState = HP_STORES_MAPS.get(this.$root);
        if (mapState) {
          mapState.resizeObserver?.disconnect();
          mapState.map.remove();
          HP_STORES_MAPS.delete(this.$root);
        }
      },

      storeHasExactCoordinates(store) {
        return store?.resolvedLatitude != null && store?.resolvedLongitude != null && !store.coordinatesAreApproximate;
      },

      getStoreMapKey(store) {
        return `${(store?.name || '').trim()}|${(store?.address || '').trim()}`;
      },

      async initMap() {
        if (this.mapReady || !this.$refs.map) return;
        if (!this.stores.some((store) => this.storeHasExactCoordinates(store))) return;

        let leaflet;
        try {
          leaflet = await loadLeaflet();
        } catch (error) {
          console.warn('Mağaza haritası yüklenemedi:', error);
          return;
        }

        // Harita, kapsayıcı görünür ve boyutluyken kurulmalı.
        this.mapReady = true;
        await this.$nextTick();

        const map = leaflet.map(this.$refs.map, { scrollWheelZoom: false }).setView([39, 35.2], 5);
        leaflet
          .tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          })
          .addTo(map);

        const mapState = {
          map,
          markersLayer: leaflet.layerGroup().addTo(map),
          markers: new Map(),
          userMarker: null,
          // En son uygulanan görünüm; kapsayıcı boyutu değişince yeniden uygulanır.
          lastView: null,
          resizeObserver: null,
        };
        HP_STORES_MAPS.set(this.$root, mapState);

        // Harita kurulduktan sonra kapsayıcı boyut değiştirirse (ilk yerleşimin tamamlanması,
        // masaüstü/mobil kırılımı, yazı tipi yüklenmesi) Leaflet eski ölçüye göre karo istediği
        // için haritanın büyük bölümü boş kalıyordu. Boyutu izleyip yeniden ölçüyoruz.
        if (typeof ResizeObserver !== 'undefined') {
          let resizeFrame = 0;
          mapState.resizeObserver = new ResizeObserver(() => {
            window.cancelAnimationFrame(resizeFrame);
            resizeFrame = window.requestAnimationFrame(() => {
              mapState.map.invalidateSize();
              this.applyMapView(mapState);
            });
          });
          mapState.resizeObserver.observe(this.$refs.map);
        }

        this.syncMapMarkers();
      },

      // Kaydedilen görünümü (sığdırma veya tek mağazaya odaklanma) yeniden uygular.
      applyMapView(mapState) {
        const leaflet = window.L;
        const view = mapState?.lastView;
        if (!leaflet || !view) return;

        if (view.type === 'center') {
          mapState.map.setView(view.center, view.zoom);
          return;
        }

        if (view.points.length === 1) {
          mapState.map.setView(view.points[0], 14);
        } else if (view.points.length > 1) {
          mapState.map.fitBounds(leaflet.latLngBounds(view.points), { padding: [32, 32], maxZoom: 15 });
        }
      },

      buildStorePopup(store) {
        const popup = document.createElement('div');
        popup.className = 'hp-stores__map-popup';

        const title = document.createElement('strong');
        title.textContent = (store.name || '').trim();
        popup.appendChild(title);

        if (store.address) {
          const address = document.createElement('p');
          address.textContent = store.address;
          popup.appendChild(address);
        }

        if (store.resolvedMapUrl) {
          const link = document.createElement('a');
          link.href = store.resolvedMapUrl;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          link.textContent = this.t('directions');
          popup.appendChild(link);
        }

        return popup;
      },

      // Filtrelenen mağazaları haritaya basar ve görünümü onlara sığdırır (şehir seçimi → o şehir).
      syncMapMarkers() {
        const mapState = HP_STORES_MAPS.get(this.$root);
        const leaflet = window.L;
        if (!mapState || !leaflet) return;

        mapState.markersLayer.clearLayers();
        mapState.markers.clear();

        if (mapState.userMarker) {
          mapState.userMarker.remove();
          mapState.userMarker = null;
        }

        const mappableStores = this.filteredStores.filter((store) => this.storeHasExactCoordinates(store));
        const focusPoints = [];

        mappableStores.forEach((store, index) => {
          const position = [store.resolvedLatitude, store.resolvedLongitude];
          const marker = leaflet
            .circleMarker(position, { radius: 7, color: '#111', weight: 2, fillColor: '#111', fillOpacity: 0.85 })
            .bindPopup(() => this.buildStorePopup(store));

          marker.addTo(mapState.markersLayer);
          mapState.markers.set(this.getStoreMapKey(store), marker);

          // "En yakın mağazalar" açıkken görünüm kullanıcıya en yakın 5 mağazaya sığdırılır.
          if (!this.nearestStoresActive || index < 5) focusPoints.push(position);
        });

        if (this.nearestStoresActive && this.userLocation?.coords) {
          const userPosition = [this.userLocation.coords.latitude, this.userLocation.coords.longitude];
          mapState.userMarker = leaflet
            .circleMarker(userPosition, { radius: 8, color: '#fff', weight: 3, fillColor: '#2563eb', fillOpacity: 1 })
            .bindTooltip('Konumunuz')
            .addTo(mapState.map);
          focusPoints.push(userPosition);
        }

        mapState.map.invalidateSize();
        mapState.lastView = { type: 'bounds', points: focusPoints };
        this.applyMapView(mapState);
      },

      // "Haritada Göster": mağazaya yakınlaşır, bilgi balonunu açar ve haritayı görünür alana getirir.
      focusStoreOnMap(store) {
        const mapState = HP_STORES_MAPS.get(this.$root);
        if (!mapState || !this.storeHasExactCoordinates(store)) return;

        const marker = mapState.markers.get(this.getStoreMapKey(store));
        this.$refs.map?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        mapState.lastView = { type: 'center', center: [store.resolvedLatitude, store.resolvedLongitude], zoom: 16 };
        this.applyMapView(mapState);
        marker?.openPopup();
      },

      closeAllDropdowns() {
        this.countryDropdownOpen = false;
        this.cityDropdownOpen = false;
      },

      toggleCountryDropdown() {
        if (this.loading || this.countries.length === 0) return;
        this.cityDropdownOpen = false;
        this.countryDropdownOpen = !this.countryDropdownOpen;
      },

      toggleCityDropdown() {
        if (this.loading || this.cities.length === 0) return;
        this.countryDropdownOpen = false;
        this.cityDropdownOpen = !this.cityDropdownOpen;
      },

      t(path) {
        return lookupHpStoresText(this.i18n, path) || lookupHpStoresText(HP_STORES_I18N_DEFAULTS, path);
      },

      getCountryLabel() {
        return this.selectedCountry === 'all' ? this.t('all_countries') : this.selectedCountry;
      },

      getCityLabel() {
        return this.selectedCity === 'all' ? this.t('all_cities') : this.selectedCity;
      },

      selectCountry(value) {
        this.closeAllDropdowns();
        if (this.selectedCountry === value) return;
        this.selectedCountry = value;
        this.onCountrySelectChange();
      },

      selectCity(value) {
        this.closeAllDropdowns();
        if (this.selectedCity === value) return;
        this.selectedCity = value;
        this.onCitySelectChange();
      },

      async getStores() {
        try {
          this.loading = true;

          const storesEndpoint = window.HC_API?.GET_STORES;

          if (!storesEndpoint) {
            console.error('HC_API.GET_STORES tanımlı değil. Holly-Constants.js yüklendi mi kontrol edin.');
            return;
          }

          if (IS_SESSION_STORAGE_ENABLED) {
            const cachedStores = sessionStorage.getItem('hp_stores');
            if (cachedStores) {
              const parsedData = JSON.parse(cachedStores);
              this.stores = parsedData
                .filter((store) => this.matchesGroupFilter(store))
                .map((store) => this.enrichStore(store));
              this.filteredStores = [...this.stores];
              this.extractLocations();
              this.loading = false;
              return;
            }
          }

          const response = await fetch(storesEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
          });
          const data = await response.json();

          if (data.isSuccess) {
            const onlyStores = (data.data || []).filter((store) => !this.getStoreType(store));
            this.stores = onlyStores
              .filter((store) => this.matchesGroupFilter(store))
              .map((store) => this.enrichStore(store));
            this.filteredStores = [...this.stores];
            this.extractLocations();

            if (IS_SESSION_STORAGE_ENABLED) {
              sessionStorage.setItem('hp_stores', JSON.stringify(onlyStores));
            }
          }
        } catch (error) {
          console.error('Mağazalar yüklenirken hata oluştu:', error);
        } finally {
          this.loading = false;
          this.$nextTick(() => this.initMap());
        }
      },

      getStoreMetaValue(store, key) {
        if (!store || !Array.isArray(store.metaValues)) return null;
        const meta = store.metaValues.find((item) => item && item.key === key);
        if (!meta) return null;
        const value = meta.value;
        if (value === null || value === undefined) return null;
        const trimmed = String(value).trim();
        return trimmed === '' ? null : trimmed;
      },

      getStoreType(store) {
        return this.getStoreMetaValue(store, 'store_type');
      },

      // Büyük/küçük harf ve Türkçe karakter farkı yok sayılır: `konsept`, `Konsept`, `KONSEPT` aynı.
      matchesGroupFilter(store) {
        if (!this.groupFilter) return true;
        return this.normalizeLocation(this.getStoreMetaValue(store, 'group')) === this.groupFilter;
      },

      formatFilterLabel(value) {
        return value ? String(value).trim() : '';
      },

      enrichStore(store) {
        const resolvedCity = this.getStoreCity(store);
        const resolvedCountry = this.getStoreCountry(store, resolvedCity);
        const coordinates = this.resolveStoreCoordinates(store, resolvedCity);

        return {
          ...store,
          resolvedCity,
          resolvedCountry,
          resolvedLatitude: coordinates?.latitude ?? null,
          resolvedLongitude: coordinates?.longitude ?? null,
          coordinatesAreApproximate: coordinates?.approximate ?? false,
          resolvedMapUrl: this.resolveStoreMapUrl(store, coordinates),
        };
      },

      // QA MGZ-08: API `mapUrl` boş geldiğinde "Yol Tarifi" linki hiç çıkmıyordu.
      // Kesin koordinat varsa Google Haritalar yol tarifi, yoksa ad + adres araması üretilir.
      resolveStoreMapUrl(store, coordinates) {
        const mapUrl = this.formatFilterLabel(store.mapUrl);
        if (mapUrl) return mapUrl;

        if (coordinates && !coordinates.approximate) {
          return `https://www.google.com/maps/dir/?api=1&destination=${coordinates.latitude},${coordinates.longitude}`;
        }

        const query = [store.name, store.address, store.city].map((part) => this.formatFilterLabel(part)).filter(Boolean).join(' ');
        return query ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}` : '';
      },

      resolveStoreCoordinates(store, resolvedCity) {
        const apiLatitude = Number.parseFloat(store.latitude);
        const apiLongitude = Number.parseFloat(store.longitude);

        if (!Number.isNaN(apiLatitude) && !Number.isNaN(apiLongitude)) {
          return { latitude: apiLatitude, longitude: apiLongitude, approximate: false };
        }

        const mapCoordinates = parseStoreMapUrlCoordinates(store.mapUrl);
        if (mapCoordinates) {
          return { ...mapCoordinates, approximate: false };
        }

        const cityCoordinates = getStoreCityCoordinates(this.normalizeLocation(resolvedCity));
        if (cityCoordinates) {
          return {
            latitude: cityCoordinates.lat,
            longitude: cityCoordinates.lng,
            approximate: true,
          };
        }

        return null;
      },

      getSearchableText(store) {
        return normalizeSearchText(
          [store.name, store.resolvedCountry, store.resolvedCity, store.district, store.address, store.phone]
            .filter(Boolean)
            .join(' ')
        );
      },

      matchesSearch(store) {
        const rawQuery = this.searchQuery.trim();
        if (!rawQuery) return true;

        const normalizedQuery = normalizeSearchText(rawQuery);
        if (normalizedQuery && this.getSearchableText(store).includes(normalizedQuery)) return true;

        const queryDigits = getSearchablePhoneDigits(rawQuery);
        if (queryDigits.length >= 3) {
          return getSearchablePhoneDigits(store.phone).includes(queryDigits);
        }

        return false;
      },

      inferCountryFromAddress(store) {
        const text = `${store.address || ''} ${store.name || ''}`;
        for (const rule of HP_STORE_ADDRESS_COUNTRY_RULES) {
          if (rule.pattern.test(text)) return rule.country;
        }
        return '';
      },

      inferTurkeyFromPhone(phone) {
        if (!phone) return false;

        const cleaned = String(phone).replace(/\s/g, '');
        if (/^(\+90|0090)/.test(cleaned)) return true;
        if (/^05\d{9}$/.test(cleaned.replace(/\D/g, ''))) return true;

        const digits = cleaned.replace(/\D/g, '');
        if (digits.startsWith('90') && digits.length >= 12) return true;
        if (/^\(?(212|216|222|224|232|242|252|256|258|262|264|266|272|274|276|282|284|286|288|312|318|322|324|326|332|338|342|344|346|348|352|354|356|358|362|364|366|368|370|372|412|414|416|422|424|432|442|446|452|462|464|472|474|476|482|484|488)\)?/.test(cleaned)) {
          return true;
        }

        return false;
      },

      inferTurkeyFromAddress(store) {
        const text = normalizeSearchText([store.address, store.name, store.district].filter(Boolean).join(' '));
        if (!text) return false;
        if (/\bturkiye\b|\bturkey\b/.test(text)) return true;

        for (const city of HP_STORE_TURKISH_CITIES) {
          if (text.includes(normalizeSearchText(city))) return true;
        }

        const extraHints = [
          'bodrum', 'kusadasi', 'beyoglu', 'besiktas', 'uskudar', 'kadikoy', 'pendik', 'maltepe', 'umraniye',
          'atasehir', 'bakirkoy', 'bahcelievler', 'basaksehir', 'sariyer', 'fatih', 'istinye', 'yuregir', 'silopi',
          'ipekyolu', 'nilufer', 'osmangazi', 'cankaya', 'yenimahalle', 'karatay', 'melikgazi', 'onikisubat',
          'sehitkamil', 'yenisehir', 'artuklu', 'kiziltepe', 'altinordu', 'tekkekoy', 'canik', 'mentese',
        ];

        return extraHints.some((hint) => text.includes(hint));
      },

      inferCityFromAddress(store) {
        const text = `${store.address || ''} ${store.name || ''}`;
        for (const rule of HP_STORE_ADDRESS_CITY_RULES) {
          if (rule.pattern.test(text)) return rule.city;
        }
        return '';
      },

      getStoreCountry(store, city) {
        if (!store) return '';

        // QA MGZ-03: API her mağaza için `country` döndürüyor; şehirden tahmin yalnızca yedek.
        // (Tahmin, eşleme tablosunda olmayan yurt dışı şehirlerini — örn. Amman — "Türkiye" sayıyordu.)
        const apiCountry = this.formatFilterLabel(store.country);
        if (apiCountry) {
          return HP_STORE_COUNTRY_ALIASES[this.normalizeLocation(apiCountry)] || apiCountry;
        }

        const resolvedCity = city || this.getStoreCity(store);
        const addressCountry = this.inferCountryFromAddress(store);

        if (resolvedCity) {
          const normalizedCity = this.normalizeLocation(resolvedCity);
          if (HP_STORE_COUNTRY_BY_CITY[normalizedCity]) return HP_STORE_COUNTRY_BY_CITY[normalizedCity];
          if (HP_STORE_TURKISH_CITIES.has(normalizedCity)) return 'Türkiye';
          if (addressCountry) return addressCountry;
          return 'Türkiye';
        }

        if (addressCountry) return addressCountry;
        if (this.inferTurkeyFromPhone(store.phone)) return 'Türkiye';
        if (this.inferTurkeyFromAddress(store)) return 'Türkiye';

        return '';
      },

      getStoreCity(store) {
        if (!store) return '';
        const city = this.formatFilterLabel(store.city);
        return city || this.inferCityFromAddress(store);
      },

      extractLocations() {
        const countrySet = new Set();
        this.stores.sort((a, b) => (a.name || '').trim().localeCompare((b.name || '').trim(), 'tr'));

        this.stores.forEach((store) => {
          if (store.resolvedCountry) countrySet.add(store.resolvedCountry);
        });

        this.countries = Array.from(countrySet).sort((a, b) => a.localeCompare(b, 'tr'));

        // QA MGZ-02: İlk yüklemede Türkiye seçili gelsin; kullanıcı "Tüm ülkeler"e dönebilir.
        if (!this.defaultCountryApplied) {
          this.defaultCountryApplied = true;
          if (this.selectedCountry === 'all' && this.countries.includes(HP_STORE_DEFAULT_COUNTRY)) {
            this.selectedCountry = HP_STORE_DEFAULT_COUNTRY;
          }
        }

        this.updateVisibleCities();
        this.filterStores();
      },

      updateVisibleCities() {
        const citySet = new Set();

        this.stores.forEach((store) => {
          const countryMatch =
            this.selectedCountry === 'all' ||
            this.normalizeLocation(store.resolvedCountry) === this.normalizeLocation(this.selectedCountry);

          if (countryMatch && store.resolvedCity) citySet.add(store.resolvedCity);
        });

        this.cities = Array.from(citySet).sort((a, b) => a.localeCompare(b, 'tr'));

        if (this.selectedCity !== 'all' && !this.cities.includes(this.selectedCity)) {
          this.selectedCity = 'all';
        }
      },

      filterStores(skipSort = false) {
        this.filteredStores = this.stores.filter((store) => {
          const countryMatch =
            this.selectedCountry === 'all' ||
            this.normalizeLocation(store.resolvedCountry) === this.normalizeLocation(this.selectedCountry);
          const cityMatch =
            this.selectedCity === 'all' ||
            this.normalizeLocation(store.resolvedCity) === this.normalizeLocation(this.selectedCity);
          return countryMatch && cityMatch && this.matchesSearch(store);
        });

        if (!skipSort && !this.nearestStoresActive) {
          this.filteredStores.sort((a, b) => (a.name || '').trim().localeCompare((b.name || '').trim(), 'tr'));
        }

        this.syncMapMarkers();
      },

      clearNearestStoresSorting() {
        this.locationRequestId += 1;
        this.locationError = '';
        this.nearestStoresRequested = false;
        this.nearestStoresLoading = false;
        this.nearestStoresActive = false;
        this.userLocation = null;
        this.stores.sort((a, b) => (a.name || '').trim().localeCompare((b.name || '').trim(), 'tr'));
      },

      hasValidDistance(store) {
        return typeof store.distance === 'number' && store.distance < 99999;
      },

      formatDistance(store) {
        if (!this.hasValidDistance(store)) return '';
        const prefix = store.distanceIsApproximate ? '~' : '';
        return `${prefix}${store.distance} km`;
      },

      onCountrySelectChange() {
        this.closeAllDropdowns();
        this.clearNearestStoresSorting();
        this.selectedCity = 'all';
        this.updateVisibleCities();
        this.filterStores();
      },

      onCitySelectChange() {
        this.closeAllDropdowns();
        this.clearNearestStoresSorting();
        this.filterStores();
      },

      formatStoreLocation(store) {
        const parts = [];
        if (store.resolvedCountry) parts.push(store.resolvedCountry);
        if (store.resolvedCity) parts.push(store.resolvedCity);
        if (store.district) parts.push(store.district);
        return parts.join(', ');
      },

      onSearchInput() {
        this.filterStores(this.nearestStoresActive);
      },

      requestNearestStores() {
        if (this.nearestStoresLoading || this.loading) return;

        this.closeAllDropdowns();
        this.locationError = '';

        if (!this.stores.length) {
          this.locationError = this.t('errors.stores_unavailable');
          return;
        }

        this.nearestStoresRequested = true;
        this.nearestStoresLoading = true;

        const requestId = ++this.locationRequestId;
        const fail = (message) => {
          if (requestId !== this.locationRequestId) return;
          this.locationError = message;
          this.nearestStoresLoading = false;
          this.nearestStoresRequested = false;
          this.nearestStoresActive = false;
        };

        if (!('geolocation' in navigator)) {
          fail(this.t('errors.geolocation_unsupported'));
          return;
        }

        try {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              if (requestId !== this.locationRequestId) return;

              if (!Number.isFinite(position.coords.latitude) || !Number.isFinite(position.coords.longitude)) {
                fail(this.t('errors.location_invalid'));
                return;
              }

              this.userLocation = position;
              this.calculateDistancesAndSort();
            },
            (error) => {
              fail(
                {
                  1: this.t('errors.permission_denied'),
                  2: this.t('errors.position_unavailable'),
                  3: this.t('errors.timeout'),
                }[error.code] || this.t('errors.location_failed'),
              );
            },
            {enableHighAccuracy: false, timeout: 20000, maximumAge: 60000},
          );
        } catch (error) {
          fail(this.t('errors.location_service_unreachable'));
        }
      },

      calculateDistancesAndSort() {
        if (!this.userLocation) return;

        const userLat = this.userLocation.coords.latitude;
        const userLng = this.userLocation.coords.longitude;

        this.stores = this.stores.map((store) => {
          const latitude = store.resolvedLatitude;
          const longitude = store.resolvedLongitude;

          if (latitude != null && longitude != null) {
            return {
              ...store,
              distance: this.calculateDistance(userLat, userLng, latitude, longitude),
              distanceIsApproximate: store.coordinatesAreApproximate,
            };
          }

          return {...store, distance: 99999, distanceIsApproximate: false};
        });

        this.stores.sort((a, b) =>
          a.distance === b.distance
            ? (a.name || '').localeCompare(b.name || '', 'tr')
            : a.distance - b.distance,
        );

        this.selectedCountry = 'all';
        this.selectedCity = 'all';
        this.updateVisibleCities();
        this.searchQuery = '';
        this.filterStores(true);

        this.nearestStoresLoading = false;
        this.nearestStoresRequested = false;
        this.nearestStoresActive = this.stores.some((store) => this.hasValidDistance(store));

        if (!this.nearestStoresActive) {
          this.locationError = this.t('errors.no_store_coordinates');
        }

        // QA MGZ-05: konum sonucunu haritaya da yansıt.
        this.syncMapMarkers();
      },

      calculateDistance(lat1, lng1, lat2, lng2) {
        const earthRadiusKm = 6371;
        const dLat = this.deg2rad(lat2 - lat1);
        const dLng = this.deg2rad(lng2 - lng1);
        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return Math.round(earthRadiusKm * c * 10) / 10;
      },

      deg2rad(deg) {
        return deg * (Math.PI / 180);
      },

      normalizeLocation(value) {
        if (!value) return '';

        return value
          .toLocaleUpperCase('TR')
          .replace(/Ğ/g, 'G')
          .replace(/Ü/g, 'U')
          .replace(/Ş/g, 'S')
          .replace(/I/g, 'I')
          .replace(/İ/g, 'I')
          .replace(/Ö/g, 'O')
          .replace(/Ç/g, 'C')
          .replace(/[^A-Z0-9]/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');
      },

      formatPhoneNumber(phone) {
        if (!phone) return '';
        const cleaned = phone.replace(/\D/g, '');
        if (cleaned.length === 11 && cleaned.startsWith('0')) {
          return `${cleaned.slice(0, 1)} ${cleaned.slice(1, 4)} ${cleaned.slice(4, 7)} ${cleaned.slice(7)}`;
        }
        return phone;
      },

      // QA R141: Pazartesi…Pazar 7 satır ({ key, day, value, isToday }). Eski özet ("Hafta içi / Hafta sonu")
      // günlerden biri farklıysa satırı hiç basmıyordu. Saat verisi obje değilse ya da tüm alanlar boşsa
      // (QA MGZ-06: API şu an tüm mağazalar için null döndürüyor) [] döner → "arayınız" metni gösterilir.
      getWorkingHoursRows(workingHours) {
        if (!workingHours || typeof workingHours !== 'object') return [];

        const rows = HP_STORE_WEEK_DAYS.map((key) => ({
          key,
          start: this.formatTime(workingHours[`${key}Start`]),
          end: this.formatTime(workingHours[`${key}End`]),
        }));
        if (!rows.some((row) => row.start || row.end)) return [];

        const today = this.todayKey();
        return rows.map(({ key, start, end }) => ({
          key,
          day: this.t(`hours.days.${key}`),
          value: start && end ? `${start} - ${end}` : '—',
          isToday: key === today,
        }));
      },

      // Tarayıcı saati (TR mağazaları için Türkiye saatiyle aynı kabul edilir).
      todayKey() {
        return HP_STORE_DAY_BY_INDEX[new Date().getDay()];
      },

      // Kapalı <details> başlığında: "Bugün: 10:00 - 22:00".
      getTodayHoursLabel(workingHours) {
        const today = this.getWorkingHoursRows(workingHours).find((row) => row.isToday);
        return today ? `${this.t('hours.today')}: ${today.value}` : '';
      },

      // Gün satırı üretilemediğinde gösterilen düz metin (x-text; eski x-html kaldırıldı).
      getWorkingHoursText(workingHours) {
        if (typeof workingHours === 'string') {
          const text = workingHours
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/<[^>]*>/g, '')
            .trim();
          if (text) return text;
        }

        return this.t('hours.call');
      },

      formatTime(timeString) {
        if (timeString === null || timeString === undefined) return '';
        return String(timeString).trim().substring(0, 5);
      },
    }));
  }

  if (window.Alpine) {
    registerHpStoresPage();
  } else {
    document.addEventListener('alpine:init', registerHpStoresPage);
  }
})();
